enum OpportunityParticipantStatus {
	New = "New"
}

export default OpportunityParticipantStatus;
